<!-- Modal -->
<div class="modal fade" id="headerFileDownload" tabindex="-1" role="dialog" aria-labelledby="headerFileDownloadLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header" style="background-color: #f5f5f5">
        <h5 class="mb-0" id="headerFileDownloadLabel">File Download</h5>
        <div class="d-flex">
          <div title="Refresh File List"><i class="fa fa-refresh pointer pe-2" (click)="resetFiles()"></i></div>
          <div><button type="button" title="Close Popup" class="close" data-bs-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button></div>
        </div>
      </div>
      <div class="modal-body">
        <ul class="nav nav-tabs" id="myTab" role="tablist">
          <li *ngIf="overlayConfig['isOverlayFileVisible']" class="nav-item">
            <a class="nav-link active text-black-50 fw-bolder text-capitalize font-size-13"
              id="overlay-files-tab" data-bs-toggle="tab" href="#overlay" role="tab" aria-controls="overlay"
              aria-selected="true">Overlay Terminating Files</a>
          </li>
          <li *ngIf="overlayConfig['isOverlayOriginatingFileVisible']" class="nav-item">
            <a class="nav-link text-black-50 fw-bolder text-capitalize font-size-13"
              id="overlay-originating-files-tab" data-bs-toggle="tab" href="#overlayOriginating" role="tab"
              aria-controls="overlayOriginating" aria-selected="false">Overlay Originating Files</a>
          </li>
          <li *ngIf="highRiskConfig['isHighRiskFileVisible']" class="nav-item">
            <a class="nav-link text-black-50 fw-bolder text-capitalize font-size-13" id="high-risk-files-tab"
              data-bs-toggle="tab" href="#highRisk" role="tab" aria-controls="highRisk" aria-selected="false">High Risk
              Files</a>
          </li>
          <li *ngIf="ticketingConfig['isTicketingFileVisible']" class="nav-item">
            <a class="nav-link text-black-50 fw-bolder text-capitalize font-size-13" id="ticketing-file-tab"
              data-toggle="tab" href="#ticketingFile" role="tab" aria-controls="ticketingFile" aria-selected="false">Ticketing
              Files</a>
          </li>
          <li *ngIf="verstatConfig['isVerstatFileVisible']" class="nav-item">
            <a class="nav-link text-black-50 fw-bolder text-capitalize font-size-13" id="ticketing-file-tab"
              data-bs-toggle="tab" href="#verstatFile" role="tab" aria-controls="ticketingFile" aria-selected="false">Verstat</a>
          </li>
        </ul>
        <div class="tab-content" id="myTabContent">
          <div class="tab-pane fade show active" id="overlay" role="tabpanel" aria-labelledby="overlay-files-tab">
            <div class="border w-100 row-highlight-custom">
              <p-treeTable [value]="overlayFileDownloadData" [scrollable]="true" scrollHeight="400px">
                <ng-template pTemplate="header">
                  <tr>
                    <th class="w-45 text-center" title="File Name">File Name</th>
                    <th class="w-15 text-center" title="Size">Size</th>
                    <th class="w-25 text-center" title="Last Modified">Last Modified</th>
                    <th class="text-center" style="width: 12%;" title="Download">Download</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
                  <tr>
                    <td class="w-45 file-name-col-custom" title="{{rowData.name}}">
                      <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                      {{rowData.name}}
                    </td>
                    <td class="text-center w-15" title="{{rowData.size}}">{{rowData.size}}</td>
                    <td class=" text-center w-25" title="{{rowData.lastModified}}">{{rowData.lastModified}}</td>
                    <td class="text-center" style="width: 12%; padding-left: 2px !important;"
                      [innerHTML]="rowData.download" (click)="downloadFile(rowData);"></td>
                  </tr>
                </ng-template>
              </p-treeTable>
              <!-- Spinner for getting API data -->
              <div *ngIf="!overlayConfig['fetchingOverlayFilesFlag']" class="spinnerContainer text-center">
                <div class="spinner-border spinnerCls" role="status">
                </div>
              </div>
            </div>
          </div>
          <div class="tab-pane fade" id="overlayOriginating" role="tabpanel"
            aria-labelledby="overlay-originating-files-tab">
            <div class="border w-100 row-highlight-custom">
              <p-treeTable [value]="overlayOriginatingFileDownloadData" [scrollable]="true" scrollHeight="400px">
                <ng-template pTemplate="header">
                  <tr>
                    <th class="w-45 text-center" title="File Name">File Name</th>
                    <th class="w-15 text-center" title="Size">Size</th>
                    <th class="w-25 text-center" title="Last Modified">Last Modified</th>
                    <th class="text-center" style="width: 12%;" title="Download">Download</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
                  <tr>
                    <td class="w-45 file-name-col-custom" title="{{rowData.name}}">
                      <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                      {{rowData.name}}
                    </td>
                    <td class="text-center w-15" title="{{rowData.size}}">{{rowData.size}}</td>
                    <td class=" text-center w-25" title="{{rowData.lastModified}}">{{rowData.lastModified}}</td>
                    <td class="text-center" style="width: 12%;padding-left: 2px !important;"
                      [innerHTML]="rowData.download" (click)="downloadFile(rowData);"></td>
                  </tr>
                </ng-template>
              </p-treeTable>
            </div>
            <!-- Spinner for getting API data -->
            <div *ngIf="!overlayConfig['fetchingOverlayOriginatingFilesFlag']" class="spinnerContainer text-center">
              <div class="spinner-border spinnerCls" role="status">
              </div>
            </div>
          </div>
          <div class="tab-pane fade" id="highRisk" role="tabpanel" aria-labelledby="high-risk-files-tab">
            <div class="border w-100 row-highlight-custom">
              <p-treeTable [value]="highRiskFileDownloadData" [scrollable]="true" scrollHeight="400px">
                <ng-template pTemplate="header">
                  <tr>
                    <th class="w-45 text-center" title="File Name">File Name</th>
                    <th class="w-15 text-center" title="Size">Size</th>
                    <th class="w-25 text-center" title="Last Modified">Last Modified</th>
                    <th class="text-center" style="width: 12%;" title="Download">Download</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
                  <tr>
                    <td class="w-45 file-name-col-custom" title="{{rowData.name}}">
                      <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                      {{rowData.name}}
                    </td>
                    <td class="text-center w-15" title="{{rowData.size}}">{{rowData.size}}</td>
                    <td class=" text-center w-25" title="{{rowData.lastModified}}">{{rowData.lastModified}}</td>
                    <td class="text-center" style="width: 12%;padding-left: 2px !important;"
                      [innerHTML]="rowData.download" (click)="downloadFile(rowData);"></td>
                  </tr>
                </ng-template>
              </p-treeTable>
            </div>
            <!-- Spinner for getting API data -->
            <div *ngIf="!highRiskConfig['fetchingHighRiskFilesFlag']" class="spinnerContainer text-center">
              <div class="spinner-border spinnerCls" role="status">
              </div>
            </div>
          </div>
          <div class="tab-pane fade" id="ticketingFile" role="tabpanel" aria-labelledby="ticketing-file-tab">
            <div class="border w-100 row-highlight-custom">
              <p-treeTable [value]="ticketingDownloadData" [scrollable]="true" scrollHeight="400px">
                <ng-template pTemplate="header">
                  <tr>
                    <th class="w-45 text-center" title="File Name">File Name</th>
                    <th class="w-15 text-center" title="Size">Size</th>
                    <th class="w-25 text-center" title="Last Modified">Last Modified</th>
                    <th class="text-center" style="width: 12%;" title="Download">Download</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
                  <tr>
                    <td class="w-45 file-name-col-custom" title="{{rowData.name}}">
                      <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                      {{rowData.name}}
                    </td>
                    <td class="text-center w-15" title="{{rowData.size}}">{{rowData.size}}</td>
                    <td class=" text-center w-25" title="{{rowData.lastModified}}">{{rowData.lastModified}}</td>
                    <td class="text-center" style="width: 12%;padding-left: 2px !important;"
                      [innerHTML]="rowData.download" (click)="downloadFile(rowData);"></td>
                  </tr>
                </ng-template>
              </p-treeTable>
            </div>
            <!-- Spinner for getting API data -->
            <div *ngIf="!ticketingConfig['fetchingTicketingFilesFlag']" class="spinnerContainer text-center">
              <div class="spinner-border spinnerCls" role="status">
              </div>
            </div>
          </div>
          <div class="tab-pane fade" id="verstatFile" role="tabpanel" aria-labelledby="verstat-file-tab">
            <div class="border w-100 row-highlight-custom">
              <p-treeTable [value]="verstatDownloadData" [scrollable]="true" scrollHeight="400px">
                <ng-template pTemplate="header">
                  <tr>
                    <th class="w-45 text-center" title="File Name">File Name</th>
                    <th class="w-15 text-center" title="Size">Size</th>
                    <th class="w-25 text-center" title="Last Modified">Last Modified</th>
                    <th class="text-center" style="width: 12%;" title="Download">Download</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
                  <tr>
                    <td class="w-45 file-name-col-custom" title="{{rowData.name}}">
                      <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                      {{rowData.name}}
                    </td>
                    <td class="text-center w-15" title="{{rowData.size}}">{{rowData.size}}</td>
                    <td class=" text-center w-25" title="{{rowData.lastModified}}">{{rowData.lastModified}}</td>
                    <td class="text-center" style="width: 12%;padding-left: 2px !important;"
                      [innerHTML]="rowData.download" (click)="downloadFile(rowData);"></td>
                  </tr>
                </ng-template>
              </p-treeTable>
            </div>
            <!-- Spinner for getting API data -->
            <div *ngIf="!verstatConfig['fetchingVerstatFilesFlag']" class="spinnerContainer text-center">
              <div class="spinner-border spinnerCls" role="status">
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex modal-footer pt-0">
        <div class="flex-grow-1">
          <span>
            <small>*Starting 2019 - The date in the file name reflects the actual volume for this date.</small><br/>
            <small>&nbsp;&nbsp;Files for the last 24 months are available.</small>
          </span>
        </div>
        <div class="pt-2">
          <ul class="d-flex file-download-footer">
            <li *ngIf="customerMailConfig['isVisible']" class="pe-2 pt-1 text-center">
              <a class="cursor-pointer text-decoration-none" title="{{customerMailConfig.title}}"
                href="{{customerMailConfig.mailAddress}}" target="_top">
                <i class="fa fa-envelope pb-2 icon-style-vz text-primary"></i>
                <i class="email-text ng-binding">Email {{activeCustomer}}</i>
              </a>
            </li>
            <li *ngIf="neustarMailConfig['isVisible']" class="pe-2 pt-1 ps-3 text-center">
              <a class="cursor-pointer text-decoration-none" title="{{neustarMailConfig.title}}"
                href="{{neustarMailConfig.mailAddress}}" target="_top">
                <i class="fa fa-envelope pb-2 icon-style-neustar"></i>
                <i class="email-text">Email Neustar</i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
